export const isComponentOfType = (sourceComponent: React.ComponentType) => (component: React.ReactElement<unknown>) =>
    component &&
    component.type &&
    sourceComponent &&
    typeof component.type !== 'string' &&
    component.type.name === sourceComponent.name;
